import React from 'react';
import TableHeaderSelected from './TableHeaderSelected/TableHeaderSelected';
import useObservable from '../../../../../Shared/Hooks/useObservable.Hook';
import TableHeader from './TableHeader/TableHeader';
import styles from './TableHeaderWrapper.css';
import { getSelectedItems } from '../../../../Services/SelectedItems.service';
import { getAppSettings } from '../../../../Services/AppSettings.service';

const TableHeaderWrapper = () => {
  const [, selectedItems]: any = useObservable(getSelectedItems());
  const [, AppSettings]: any = useObservable(getAppSettings());
  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : '';
  return (
    <>
      {selectedItems && selectedItems.length === 0 ? (
        <div
          className={
            isMobile
              ? styles.TableMobileHeaderContainer
              : styles.TableHeaderContainer
          }
          role="rowgroup"
        >
          <TableHeader />
        </div>
      ) : (
        <>
          {!isMobile ? (
            <div className={styles.TableHeaderContainer}>
              <TableHeaderSelected />
            </div>
          ) : null}
        </>
      )}
    </>
  );
};

export default TableHeaderWrapper;
